import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
    ICreateGroupDTO,
    ICreateGroupRequestParams,
    IGetGroupsResponseDTO, 
    IGetUserGroupsResponseItemDTO, IGetUserWorkspaceSearchDTO,
    IUpdateGroupRequestParams} from './interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  constructor (private http:HttpClient) {}

    /**
     * Fetch groups
     * @returns response
     */
    fetchGroups(){
      return this.http.get<IGetGroupsResponseDTO[]>(`security/groups`);
    }

    /**
     * create groups
     * @param formData
     * @returns response
     */
    createGroup(formData: ICreateGroupRequestParams){
      return this.http.post<ICreateGroupDTO>('security/groups', formData);
    }

    /**
     * Delete group
     * @param id
     * @returns response
     */
    deleteGroup(id: number){
      return this.http.delete(`security/groups/${id}`);
    }

    
    /**
     * Update group details
     * @param id
     * @param formData
     * @returns response
     */
    updateGroupDetails(id:number, formData: IUpdateGroupRequestParams):Observable<IGetGroupsResponseDTO>{
      return this.http.put<IGetGroupsResponseDTO>(`security/groups/${id}`, formData);
    }

    /**
     * Search user
     * @param q
     * @returns response
     */
    searchUser(q: string){
      return this.http.get<IGetUserWorkspaceSearchDTO[]>(`workspaces/current/users-search?name=${q}`);
    }


    /**
     * Fetch group users
     * @param groupId
     * @returns response
     */
    fetchGroupUsers(groupId: number){
      return this.http.get<IGetUserGroupsResponseItemDTO[]>(`security/groups/${groupId}/group-users`);
    }
    
 

    /**
     * Set group as default
     * @param groupId 
     * @returns response
    */
    setDefault(groupId: number){
      return this.http.put(`security/groups/${groupId}/default`,'');
    }

    /**
     * Rename group
     * @param formData
     * @returns response
     */
    renameGroup(groupId: number, groupName: string){
      return this.http.put<ICreateGroupDTO>(`security/groups/${groupId}`, {name: groupName});
    }
}
